import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-brightness-medium",
  templateUrl: "./med-icon-brightness-medium.component.html",
})
export class MedIconBrightnessMediumComponent extends SvgMixinComponent {}
